import { activeLoader, setLicenseExpireFlag } from './view.actions';
import { cardLibraryService } from '../services/card-library.service';
import { CONFIG } from '../helper/config';
import { ChartConfigInfo } from '../modal/filters';
import { errorBoundaryService } from '../services/error-boundary.service';

export const cardLibraryActions = {
  SET_TEAM_CARD: 'SET_TEAM_CARD',
  SET_DEPENDENT_FILTER_DATA: 'SET_DEPENDENT_FILTER_DATA',
  SET_CARD_LIBRARY_MESSAGE: 'SET_CARD_LIBRARY_MESSAGE',
  UPDATE_FILTER_COLUMNS: 'UPDATE_FILTER_COLUMNS',
  UPDATECHARTVIEWSTATE: 'UPDATECHARTVIEWSTATE',
  UPDATETEAMSDEFAULTVIEW: 'UPDATETEAMSDEFAULTVIEW',
  UPDATEFILTER:'UPDATEFILTER',
  SET_COLUMN_FILTER_DATA:'SET_COLUMN_FILTER_DATA',
  SET_SEARCH_FILTER_DATA:'SET_SEARCH_FILTER_DATA',
  UPDATE_FILTER_OBJ:'UPDATE_FILTER_OBJ',
  SET_FALLBACK_UI:'SET_FALLBACK_UI',
  SET_ACCESS_FALLBACK_UI:'SET_ACCESS_FALLBACK_UI',
  SET_TOKEN_FALLBACK_UI:'SET_TOKEN_FALLBACK_UI',
  DOWNLOAD_CSV: "DOWNLOAD_CSV",
  FETCH_USER_LOCATION: "FETCH_USER_LOCATION",
  SET_TOKEN_FALLBACK_DETAILS:'SET_TOKEN_FALLBACK_DETAILS'
};

/**
 * update team card state to store
 */
export const setTeamCard = (card: any) => (
  dispatch: (arg0: { type: string; payload: { team_card: any } }) => void
) => {
  dispatch({
    type: cardLibraryActions.SET_TEAM_CARD,
    payload: { team_card: card },
  });
};

/**
 * Set a message to show in the card library UI.
 * @param {string} msg The message to show.
 * @returns {function(*): {type: string, payload: {card_library_msg: string}}}
 */
export const setCardLibraryMessage = (msg: string) => (dispatch: (arg0: { type: string; payload: { card_library_msg: string; }; }) => void) => {
  dispatch({
    type: cardLibraryActions.SET_CARD_LIBRARY_MESSAGE,
    payload: { card_library_msg: msg },
  });
};

/**
 * Set the dependent filter data.
 * @param {object} filter_data The filter data to set for dependent filters.
 * @returns {function(*): {type: string, payload: {dependent_filter_data: object}}}
 */
export const setDependentFilterData = (filter_data: any) => (
  dispatch: (arg0: { type: string; payload: { dependent_filter_data: any } }) => void
) => {
  dispatch({
    type: cardLibraryActions.SET_DEPENDENT_FILTER_DATA,
    payload: { dependent_filter_data: filter_data },
  });
};

/**
 * Set the filter columns state to store.
 * @param {object} filter_columns The filter columns data to set.
 * @returns {function(*): {type: string, payload: {filter_columns: object}}}
 */
export const updateFilterColumns = (filter_columns: any) => (
  dispatch: (arg0: { type: string; payload: { filter_columns: any } }) => void
) => {
  dispatch({
    type: cardLibraryActions.UPDATE_FILTER_COLUMNS,
    payload: { filter_columns },
  });
};

/**
 * Catch and handle errors in the actions.
 * @param {any} error The error to handle.
 * @param {boolean} [is_loader=true] Whether to dispatch the active loader
 *                                action or not.
 * @returns {function(*): void}
 */
export const handleCatch = (error, is_loader: boolean = true) => (dispatch: (arg0: any) => void) => {
  if (is_loader)
    dispatch(activeLoader(false));
  if (error.expiry) {
    dispatch(setLicenseExpireFlag(true));
  } else {
    error = (typeof error === 'string'  ||  typeof error === 'object')? error : CONFIG.API.ERRORMESSAGE.FAILEDTOFATCH;
    if(error!==CONFIG.ACCESSREVOKED && error.message!==CONFIG.ACCESSREVOKED && error.message!==CONFIG.TOKENFALLBACK){
    dispatch(setCardLibraryMessage(error ?? error.message));
    }
  }
}

/**
 * Fetches the dependent filter data for the given info, port number and auth token.
 * @param {object} info The info object containing the necessary data.
 * @param {string} port_no The port number to use for the request.
 * @param {string} auth_token The authentication token to use for the request.
 * @returns {function(*): void}
 */
export const getFilterData = (info: any, port_no: string, auth_token: string) => (
  dispatch: (arg0: any) => void
) => {
  let services_: any = []
    services_.push(cardLibraryService.getDependentFilterData(info, port_no, auth_token));
  Promise.all(services_)
    .then((results) => {
      dispatch(setDependentFilterData(results[0]));
    })
    .catch((error) => {
      dispatch(handleCatch(error));
    });
};

/**
 * Fetches the team card data for the given info and auth token.
 * @param {object} info The info object containing the necessary data.
 * @param {string} auth_token The authentication token to use for the request.
 * @returns {function(*): void}
 */
export const getSelectedCard = (info: any, auth_token: string) => (
  dispatch: (arg0: any) => void
) => {
  dispatch(activeLoader(true));

  cardLibraryService
    .getTeamCard(info, auth_token)
    .then((result) => {
      dispatch(setTeamCard(result));
      if(result?.table_data?.warning || result.table_data?.data?.length===0){ 
      dispatch(setCardLibraryMessage(result.table_data.warning))
      }
      console.log("team card data :: ", result);
      dispatch(activeLoader(false));
    })
    .catch((error: any) => {
      dispatch(setTokenErroFallbackDetails(error.info || error));
      let card_error_info={...info,
      session_id:new Date().toString(),
      data:{
        error:{
          logError:`Data json API not working (${error})`,
          stack:error
        }
      }}
      errorBoundaryService.logNewError(auth_token,card_error_info).then((res)=>console.log(res))
      if(error.message === CONFIG.ACCESSREVOKED){
        dispatch(getAccessRevokeFallback(true))
      }else if(error.message === CONFIG.TOKENFALLBACK || error.message.detail === CONFIG.TOKENFALLBACK){
        
        dispatch(getTokenFallback(true))
      }else{
        dispatch(handleCatch(error))
        dispatch(getFallback(true))
      }
    });
};

/**
 * Dispatches an action to set the token error fallback state.
 * @param {object} error - details for token error.
 * @returns {function} A thunk that dispatches the action to update the token error state.
 */
export const setTokenErroFallbackDetails = (error:any) => (dispatch:any) => {
    dispatch({
      type: cardLibraryActions.SET_TOKEN_FALLBACK_DETAILS, 
      payload: {token_fallback_details:error} 
    })
}

/**
 * Dispatches an action to set the fallback UI state.
 * @param {boolean} fallback_ui - Indicates whether the fallback UI should be shown.
 * @returns {function} A thunk that dispatches the action to update the fallback UI state.
 */
export const getFallback=(fallback_ui:boolean)=>(dispatch:any)=>{
  dispatch({
    type: cardLibraryActions.SET_FALLBACK_UI,
    payload: {fallback_ui:fallback_ui}
  })
}

/**
 * Dispatches an action to set the access revoke fallback UI state.
 * @param {boolean} access_revoke_fallback_ui - Indicates whether the access revoke fallback UI should be shown.
 * @returns {function} A thunk that dispatches the action to update the access revoke fallback UI state.
 */
export const getAccessRevokeFallback=(access_revoke_fallback_ui:boolean)=>(dispatch:any)=>{
  dispatch({
    type: cardLibraryActions.SET_ACCESS_FALLBACK_UI,
    payload: {access_revoke_fallback_ui:access_revoke_fallback_ui}
  })
}

/**
 * Dispatches an action to set the token fallback UI state.
 * @param {boolean} token_fallback_ui - Indicates whether the token fallback UI should be shown.
 * @returns {function} A thunk that dispatches the action to update the token fallback UI state.
 */

export const getTokenFallback=(token_fallback_ui:boolean)=>(dispatch:any)=>{
  dispatch({
    type: cardLibraryActions.SET_TOKEN_FALLBACK_UI,
    payload: {token_fallback_ui:token_fallback_ui}
  })
}

/**
 * Fetches the dependent filter data for the given info, port number and auth token.
 * @param {object} info The info object containing the necessary data.
 * @param {string} port_no The port number to use for the request.
 * @param {string} auth_token The authentication token to use for the request.
 * @returns {function(*): void}
 */
export const getDependentFilterData = (info: any, port_no: string, auth_token: string) => (
  dispatch: (arg0: any) => void
) => {
  dispatch(activeLoader(true));

  cardLibraryService
    .getDependentFilterData(info, port_no, auth_token)
    .then((result) => {
      dispatch(setDependentFilterData(result));
      dispatch(activeLoader(false));
    })
    .catch((error: any) => {
      if(error!==CONFIG.ACCESSREVOKED && error.message!==CONFIG.TOKENFALLBACK){
      dispatch(handleCatch(error))
      }
    });
};

/**
 * Updates the filter state and fetches updated filter data for the given info, port number, and auth token.
 * Dispatches actions to manage loading states, chart view state, and filter state.
 * Sets team card data and card library messages based on the results received.
 * @param {object} info - The info object containing the necessary data, including filter columns.
 * @param {string} port_no - The port number to use for the request.
 * @param {string} auth_token - The authentication token to use for the request.
 * @returns {function} A thunk that dispatches various actions based on the result of the filter data update.
 */
export const updateFilter = (info: any, port_no: string, auth_token: string) => (
  dispatch: (arg0: any) => void
) => {
  dispatch(activeLoader(true));
  dispatch(updateFilterState(true));
  cardLibraryService
    .updateFilterData(info, port_no, auth_token)
    .then((result) => {
      dispatch(updateChartViewState(false));
      dispatch(updateFilterState(false));
      dispatch(setTeamCard(result));
      if(result?.table_data?.warning || result.table_data?.data?.length===0){ 
      dispatch(setCardLibraryMessage(result?.table_data?.warning))
      }
      dispatch(updateFilterColumns(info.filter_columns));
      dispatch(activeLoader(false));
    })
    .catch((error: any) => {
      dispatch(handleCatch(error));
    });
};

/**
 * Dispatches an action to update the chart view state in the card library reducer.
 * @param {boolean} is_update_chart_view_state - The new value for the chart view state.
 * @returns {function} A thunk that dispatches an action to update the chart view state.
 */
export const updateChartViewState = (is_update_chart_view_state: boolean) => (dispatch: (arg0: { type: string; payload: { is_update_chart_view_state: boolean; }; }) => void) => {
  dispatch({
    type: cardLibraryActions.UPDATECHARTVIEWSTATE,
    payload: { is_update_chart_view_state },
  });
};

/**
 * Dispatches an action to update the teams default view in the card library reducer.
 * @param {ChartConfigInfo} teams_default_view - The new value for the teams default view.
 * @returns {function} A thunk that dispatches an action to update the teams default view.
 */
export const updateTeamsDefaultView = (teams_default_view: ChartConfigInfo) =>
  (dispatch: (arg0: { type: string; payload: { teams_default_view: ChartConfigInfo }; }) => void) => {
    dispatch({
      type: cardLibraryActions.UPDATETEAMSDEFAULTVIEW,
      payload: { teams_default_view },
    });
  };

/**
 * Dispatches an action to update the update filter state in the card library reducer.
 * @param {boolean} update_filter - The new value for the update filter state.
 * @returns {function} A thunk that dispatches an action to update the update filter state.
 */
  export const updateFilterState = (update_filter: boolean) => (dispatch: (arg0: { type: string; payload: { update_filter: boolean; }; }) => void) => {
    dispatch({
      type: cardLibraryActions.UPDATEFILTER,
      payload: { update_filter },
    });
  };
  

/**
 * Dispatches an action to fetch the CSV data for the given info, auth token, and optionally, Microsoft Teams (ms) object.
 * If the screen width is greater than the mobile width threshold, it calls the downloadCsv service and dispatches actions to
 * manage loading states and handle errors.
 * If the screen width is less than the mobile width threshold, it dispatches an action to handle the error message.
 * @param {object} info - The info object containing the necessary data.
 * @param {string} auth_token - The authentication token to use for the request.
 * @param {object} [ms] - The Microsoft Teams object, if applicable.
 * @param {any} [origin] - The origin of the request, if applicable.
 * @returns {function} A thunk that dispatches various actions based on the result of the CSV data fetch.
 */
  export const getCsv= (info: any , auth_token: string, ms?: any,origin:any=null)=>(
    dispatch: (arg0: any) => void
  )=>{
    dispatch(activeLoader(true))
    if(window.screen.width > CONFIG.PVP.MOBILEWIDTH){
      cardLibraryService.downloadCsv(info, auth_token).then((result)=>{
        if(ms){
          ms.dialog.url.submit()
        }
        if(!origin){
        window.parent.postMessage("message-recieved", info.webAppUrl);
        }
        dispatch(activeLoader(false))
      }).catch((error: any) => {
        dispatch(handleCatch(error))
        dispatch(activeLoader(false))
      }) 
    }else{
      dispatch(handleCatch(CONFIG.CSVDOWNLOADMESSAGE))
    }
  }

/**
 * Dispatches an action to fetch the user location for the given info, auth token, and optionally, Microsoft Teams (ms) object.
 * If the screen width is greater than the mobile width threshold, it calls the fetchUserLocation service and dispatches actions to
 * manage loading states and handle errors.
 * If the screen width is less than the mobile width threshold, it dispatches an action to handle the error message.
 * @param {object} info - The info object containing the necessary data.
 * @param {string} auth_token - The authentication token to use for the request.
 * @param {object} [ms] - The Microsoft Teams object, if applicable.
 * @param {any} [origin] - The origin of the request, if applicable.
 * @returns {function} A thunk that dispatches various actions based on the result of the user location fetch.
 */
  export const fetchUserLocation= (info: any , auth_token: string, ms?: any,origin:any=null)=>(
    dispatch: (arg0: any) => void
  )=>{
    dispatch(activeLoader(true))
      cardLibraryService.fetchUserLocation(info, auth_token).then((result)=>{
        if(ms){
          ms.dialog.url.submit()
        }
        if(info.platform==='webapp'){
          window.parent.postMessage("message-recieved", info.webAppUrl);
        }
        dispatch(activeLoader(false))
      }).catch((error: any) => {
        dispatch(handleCatch(error))
        dispatch(activeLoader(false))
      }) 
  }

/**
 * Dispatches an action to fetch the multiple dropdown options for the given info and auth token.
 * If the event is 'focus', it dispatches actions to set the column filter data and search filter data.
 * If the event is not 'focus', it dispatches an action to set the search filter data.
 * @param {object} info - The info object containing the necessary data.
 * @param {string} auth_token - The authentication token to use for the request.
 * @param {string} event - The event that triggered the action.
 * @returns {function} A thunk that dispatches various actions based on the result of the multiple dropdown options fetch.
 */
  export const getMultipleDropdownOptions = (info: any,auth_token: string,event) => (
    dispatch: (arg0: any) => void
  ) => {
    cardLibraryService
      .getMultipleDropdownOptions(info,auth_token)
      .then((result) => {
        if(event==='focus'){
        dispatch(setColumnFilterData(result));
        dispatch(setSearchFilterData(result)); 
        }else{
          dispatch(setSearchFilterData(result)); 
        }
      })
      .catch((error: any) => {
        dispatch(handleCatch(error));
      });
  };

/**
 * Dispatches an action to set the column filter data in the card library reducer.
 * @param {object} column_filter_data - The column filter data to set.
 * @returns {function} A thunk that dispatches an action to set the column filter data.
 */
  export const setColumnFilterData=(column_filter_data:any)=>(dispatch:any)=>{
    dispatch({
      type: cardLibraryActions.SET_COLUMN_FILTER_DATA,
      payload: {column_filter_data}
    })
  }
  
/**
 * Dispatches an action to set the search filter data in the card library reducer.
 * @param {object} search_filter_data - The search filter data to set.
 * @returns {function} A thunk that dispatches an action to set the search filter data.
 */
  export const setSearchFilterData=(search_filter_data:any)=>(dispatch:any)=>{
    dispatch({
      type: cardLibraryActions.SET_SEARCH_FILTER_DATA,
      payload: {search_filter_data}
    })
  }

  /**
   * Dispatches an action to update the filter object in the card library reducer.
   * @param {object} search_filter_obj - The search filter object to update.
   * @returns {function} A thunk that dispatches an action to update the filter object.
   */
  export const updateFiltersObj=(search_filter_obj)=>(dispatch:any)=>{
    dispatch({
      type: cardLibraryActions.UPDATE_FILTER_OBJ,
      payload: {search_filter_obj}
    })
  }